import { UserStatus } from "@prisma/postgresClient";
export default UserStatus;
